/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTargetMoveInDateByIdRequest
 */
export interface UpdateTargetMoveInDateByIdRequest {
    /**
     * 
     */
    target_move_in_date: Date;
}

/**
 * Check if a given object implements the UpdateTargetMoveInDateByIdRequest interface.
 */
export function instanceOfUpdateTargetMoveInDateByIdRequest(value: object): value is UpdateTargetMoveInDateByIdRequest {
    if (!('target_move_in_date' in value) || value['target_move_in_date'] === undefined) return false;
    return true;
}

export function UpdateTargetMoveInDateByIdRequestFromJSON(json: any): UpdateTargetMoveInDateByIdRequest {
    return UpdateTargetMoveInDateByIdRequestFromJSONTyped(json, false);
}

export function UpdateTargetMoveInDateByIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTargetMoveInDateByIdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'target_move_in_date': (json['target_move_in_date'] == null ? json['target_move_in_date'] : parseDate(json['target_move_in_date'])),
    };
}

export function UpdateTargetMoveInDateByIdRequestToJSON(json: any): UpdateTargetMoveInDateByIdRequest {
    return UpdateTargetMoveInDateByIdRequestToJSONTyped(json, false);
}

export function UpdateTargetMoveInDateByIdRequestToJSONTyped(value?: UpdateTargetMoveInDateByIdRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target_move_in_date': value['target_move_in_date'] == null ? value['target_move_in_date'] : serializeDate(value['target_move_in_date']),
    };
}

